import PropTypes from 'prop-types';

// PROPTYPE
export const ParentOrderPropTypes = {
  parentOrderId: PropTypes.number,
  paydWithPoints: PropTypes.number,
  paydWithCash: PropTypes.number,
  clientExternalId: PropTypes.any,
  valueDescription: PropTypes.string,
};

export const OrderPropTypes = {
  id: PropTypes.number,
  vendorId: PropTypes.number,
  vendorName: PropTypes.string,
  vendorOrderId: PropTypes.string,
  statusId: PropTypes.number,
  status: PropTypes.string,
  orderDate: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      productSkuId: PropTypes.string,
      productImageUrl: PropTypes.string,
      productName: PropTypes.string,
      quantity: PropTypes.number,
      valueDescription: PropTypes.string,
    }),
  ),
};

export const OrdersArrayPropTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      ...ParentOrderPropTypes,
      order: PropTypes.arrayOf(PropTypes.shape({ ...OrderPropTypes })),
    }),
  ),
};

export const PaginationOrdersPropType = {
  offset: PropTypes.number,
  total: PropTypes.number,
  limit: PropTypes.number,
};

// DEFAULT VALUES PROPS
export const ParentOrderDefaultProps = {
  parentOrderId: 0,
  paydWithPoints: 0,
  paydWithCash: 0,
  clientExternalId: null,
  valueDescription: '',
};

export const OrderDefaultProps = {
  id: 0,
  vendorId: 0,
  vendorName: '',
  vendorOrderId: '',
  statusId: 0,
  status: '',
  orderDate: '',
  items: [],
};

export const OrdersArrayDefaultProps = {
  data: [{ ...ParentOrderDefaultProps, orders: [] }],
};

export const PaginationOrdersDefaultValue = {
  offset: 0,
  total: 0,
  limit: 0,
};
